import React, { useState, useEffect, createRef } from 'react';
import CardContainer from '../../components/card/card-container.jsx';
import ModalEntrega from '../../components/modal/modal-entrega.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import Swal from 'sweetalert2';

import EntregasXProductorTable from './entregas-x-productor-table.jsx';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import SearchColumn from '../../components/search/search-column.jsx';

import { subscribe, unsubscribe } from '../../components/events';
// import toggleIds from '../../utils/toggleIds.js';
import { useHistory } from 'react-router-dom';
import { useCoopConfig, getIdCatCreditoPrecosecha } from '../../components/content/coop-config.jsx';
// import transformWord from '../../utils/transformWord.js';
import xlsx from 'json-as-xlsx';
import insertIf from '../../utils/insertIf.js';
import getBackgroundColor from '../../utils/getBackgroundColor.js';
import getColor from '../../utils/getColor.js';
import LinkDownloadExcel from '../../components/link/link-download-excel.jsx';
import ListToolbar, { BtnNuevo, BtnSecundario, BtnEliminar } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import { Productos } from '../../constants/Productos.js';
import transformWord from '../../utils/transformWord.js';

const EntregasXProductorList = () => {
  const history = useHistory();
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const isCafeOrPimienta = () => {
    return [Productos.CAFE, Productos.PIMIENTA].includes(+coopConfig?.config?.cooperativa?.producto?.id);
  };
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [ids, setIds] = useState([]);
  const [folios, setFolios] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const dialog = createRef();
  const [menuVisible, setMenuVisible] = useState(false);
  const [date, setDate] = useState(null);
  const [report, setReport] = useState('all');
  const [blockingReport, setBlockingReport] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [producto, setProducto] = useState('café');
  const menuRef = createRef();

  useEffect(() => {
    if (coopConfig?.config?.cooperativa?.producto?.nombre) {
      setProducto(coopConfig.config.cooperativa.producto.nombre);
    }
  }, [coopConfig.config]);

  // columnas movidas al componente EntregasXProductorTable

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'fecha_acopio', label: 'FECHA ENTREGA' },
      { value: 7, target: 'folio_acopio', label: 'FOLIO RECIBIDO' },
      { value: 5, target: 'productor_clave_tx', label: 'CLAVE' },
      ...insertIf(!!+coopConfig.config?.usa_codigo_tx, { value: 6, target: 'productor_codigo_tx', label: 'CÓDIGO' }),
      { value: 8, target: 'productor_nombre', label: 'NOMBRE PRODUCTOR' },
      { value: 9, target: 'localidad', label: 'LOCALIDAD' },
      { value: 10, target: 'region', label: 'REGIÓN' },
      { value: 11, target: 'centro_acopio', label: 'CENTRO DE ACOPIO' },
      { value: 12, target: 'cuenta_categoria', label: 'CATEGORÍA PRODUCTOR' },
      ...insertIf(+coopConfig.config?.cooperativa?.producto?.id === Productos.MIEL, {
        value: 3,
        target: 'tambor',
        label: 'TAMBORES',
      }),

      ...insertIf(isCafeOrPimienta(), {
        value: 2,
        target: 'tipo_cafe',
        label: 'TIPO DE ' + transformWord(producto, ['uppercase']),
      }),
      ...insertIf(isCafeOrPimienta(), { value: 2, target: 'proceso', label: 'PROCESO' }),
      ...insertIf(coopConfig.mostrarTipo(), { value: 2, target: 'tipos_entregas', label: 'CATEGORÍA' }),
      ...insertIf(coopConfig.mostrarCostalera(), { value: 2, target: 'nombre_cat_costaleras_estatus', label: 'COSTALERA' }),
      ...insertIf(coopConfig.mostrarLote(), { value: 2, target: 'nombre_lote', label: 'LOTE' }),
      { value: 13, target: 'no_bultos', label: 'Nº RECIPIENTES' },
      { value: 14, target: 'peso_bruto', label: `PESO BRUTO (${coopConfig.acopioUnits()?.abreviacion})` },
      { value: 15, target: 'peso_tara', label: `PESO TARA (${coopConfig.acopioUnits()?.abreviacion})` },
      ...insertIf(coopConfig.mostrarDescuento() && !coopConfig.mostrarDescuentosPorcentaje(), {
        value: 16,
        target: 'peso_descuento',
        label: `PESO DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (${coopConfig.acopioUnits()?.abreviacion})`,
      }),
      ...insertIf(coopConfig.mostrarDescuento() && coopConfig.mostrarDescuentosPorcentaje(), {
        value: 17,
        target: 'peso_descuento_perc',
        label: `DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (%)`,
      }),
      ...insertIf(coopConfig.mostrarDescuentoHumedad() && !coopConfig.mostrarDescuentosPorcentaje(), {
        value: 18,
        target: 'peso_descuento_humedad',
        label: `PESO DESCUENTO HUMEDAD (${coopConfig.acopioUnits()?.abreviacion})`,
      }),
      ...insertIf(coopConfig.mostrarDescuentoHumedad() && coopConfig.mostrarDescuentosPorcentaje(), {
        value: 19,
        target: 'peso_descuento_humedad_perc',
        label: `DESCUENTO HUMEDAD (%)`,
      }),
      { value: 20, target: 'peso_neto', label: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})` },
      ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
        value: 21,
        target: 'peso_neto_extra',
        label: `PESO NETO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
      }),
      ...insertIf(!coopConfig.hasAcopioUnitsExtra(), { value: 22, target: 'precio_por_kg', label: 'PRECIO A PRODUCTOR' }),
      ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
        value: 23,
        target: 'precio_por_kg_extra',
        label: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnitsExtra()?.abreviacion})`,
      }),
      { value: 24, target: 'importe_total', label: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})` },
      { value: 25, target: 'total_anticipos_recuperados', label: 'DESCUENTOS DEUDAS' },
      { value: 26, target: 'pagado_a_productor', label: `PAGADO A PRODUCTOR (${coopConfig.currency()?.symbol})` },
      { value: 27, target: 'total_saldo', label: `SALDO DE LA ENTREGA (${coopConfig.currency()?.symbol})` },
      { value: 28, target: 'metodo_pago', label: 'MÉTODO DE PAGO' },
    ],
    [coopConfig]
  );

  useEffect(() => {
    if (ciclo.id) {
      dialog.current.setIdCiclo(ciclo.id);
    }
  }, [ciclo]);

  useEffect(() => {
    dialog.current.setIdsAcopios(ids.join(','));
  }, [ids]);

  useEffect(() => {
    dialog.current.setFolios(folios);
  }, [folios]);

  useEffect(() => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    setDate(curr.toISOString().substring(0, 10));

    subscribe('Entrega::onSave', e => handleSave(e));

    return () => {
      unsubscribe('Entrega::onSave');
    };
  }, []);

  const setFilter = value => {
    setCiclo(value.target);
    updateData(value.target.id);
  };

  const updateData = id_ciclo => {
    setBlocking(true);
    Api.Acopio.search('entregas_por_productor', {
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
    })
      .then(response => {
        setData(response.data);
        setOriginalData(response.data);

        var folios = response.data
          .filter(function(item) {
            return item.folio_entrega != null && item.folio_entrega != '-' && item.folio_entrega != '';
          })
          .map(function(item) {
            return { value: item.folio_entrega, label: item.folio_entrega, date: item.fecha_entrega + ' 12:00:00' };
          })
          .sort(function(a, b) {
            if (a.date < b.date) return 1;
            if (a.date > b.date) return -1;
            return 0;
          })
          .filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                t => t.value === value.value // && t.name === value.name
              )
          )
          .sort(function(a, b) {
            if (a.value < b.value) return -1;
            if (a.value > b.value) return 1;
            return 0;
          });

        setFolios(folios);

        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('error', e);
        setBlocking(false);
      });
  };

  const setDataFilter = data => {
    setData(data);
  };

  const handleSave = event => {
    setIds([]);

    Swal.fire({
      icon: 'success',
      title: '',
      text: `Se asignó con éxito el folio ${event.detail.folio} a los acopios seleccionados.`,
    });

    updateData(event.detail.id_ciclo);
  };

  const handleDownloadReport = event => {
    event.preventDefault();
    if (report !== 'all') {
      const filteredDataByDate = data.filter(item => item.fecha_acopio === date);
      exportarXlsx(filteredDataByDate, `entregas_acopios_${ciclo.id}_deFecha_${date}`);
    } else {
      exportarXlsx(data, `entregas_acopios_${ciclo.id}`);
    }
    setMenuVisible(false);
  };

  const eliminarEntrega = () => {
    Swal.fire({
      title: 'El registro de entrega seleccionado se eliminará',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      confirmButtonColor: '#FF5733',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#f4f4f4',
    }).then(result => {
      if (result.isConfirmed) {
        Api.delete('admin/acopios/entregas', selectedData.acopio_uuid)
          .then(response => {
            if (response.data.success === 1) {
              updateData(ciclo.id);

              Swal.fire({
                icon: 'success',
                title: '',
                text: `Se eliminó el registro seleccionado.`,
              });
            }
          })
          .catch(e => {
            // eslint-disable-next-line no-console
            console.log('error: ', e);
          });
      }
    });
  };

  const exportarXlsx = (data, filename) => {
    const isNum = v => v !== null && v !== undefined && !isNaN(Number(v));
    const toPercent = v => (isNum(v) ? Number(v) / 100 : null);
    const toNumber = v => (isNum(v) ? Number(v) : null);
    let xlsData1 = [
      {
        sheet: 'AcopiosXproductor',
        columns: [
          { label: 'FECHA ENTREGA', value: 'fecha_acopio' },
          { label: 'FOLIO ENTREGA', value: 'folio_acopio' },
          { label: 'CLAVE', value: 'productor_clave_tx' },
          ...insertIf(!!+coopConfig.config?.usa_codigo_tx, { label: 'CÓDIGO', value: 'productor_codigo_tx' }),
          { label: 'NOMBRE PRODUCTOR', value: 'productor_nombre' },
          { label: 'LOCALIDAD', value: 'localidad' },
          { label: 'REGIÓN', value: 'region' },
          { label: 'CENTRO DE ACOPIO', value: 'centro_acopio' },
          { label: 'CATEGORÍA ORGÁNICA', value: 'cuenta_categoria' },
          ...insertIf(!!+coopConfig.config?.usa_eudr, { label: 'RIESGO EUDR', value: 'riesgo_eudr_label' }),
          ...insertIf(isCafeOrPimienta(), {
            label: 'TIPO DE ' + transformWord(producto, ['uppercase']),
            value: 'tipo_cafe',
          }),
          ...insertIf(isCafeOrPimienta(), {
            label: 'PROCESO',
            value: 'proceso',
          }),
          ...insertIf(coopConfig.mostrarTipo(), {
            label: 'CATEGORÍA',
            value: 'tipos_entregas',
          }),
          ...insertIf(coopConfig.mostrarCostalera(), { label: 'COSTALERA', value: 'nombre_cat_costaleras_estatus' }),
          ...insertIf(coopConfig.mostrarLote(), { label: 'LOTE', value: 'nombre_lote' }),
          { label: 'Nº RECIPIENTES', value: row => +row.no_bultos },
          { label: `PESO BRUTO (${coopConfig.acopioUnits()?.abreviacion})`, value: row => +row.peso_bruto, format: '0.00' },
          { label: `PESO TARA (${coopConfig.acopioUnits()?.abreviacion})`, value: row => +row.peso_tara, format: '0.00' },
          ...insertIf(coopConfig.mostrarDescuento() && !coopConfig.mostrarDescuentosPorcentaje(), {
            label: `PESO DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (${coopConfig.acopioUnits()?.abreviacion})`,
            value: row => +row.peso_descuento,
            format: '0.00',
          }),
          ...insertIf(coopConfig.mostrarDescuento() && coopConfig.mostrarDescuentosPorcentaje(), {
            label: `DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (%)`,
            value: row => +row.peso_descuento_perc / 100,
            format: '0.00%',
          }),
          ...insertIf(coopConfig.mostrarDescuentoHumedad() && !coopConfig.mostrarDescuentosPorcentaje(), {
            label: `PESO DESCUENTO HUMEDAD (${coopConfig.acopioUnits()?.abreviacion})`,
            value: row => +row.peso_descuento_humedad,
            format: '0.00',
          }),
          ...insertIf(coopConfig.mostrarDescuentoHumedad() && coopConfig.mostrarDescuentosPorcentaje(), {
            label: `DESCUENTO HUMEDAD (%)`,
            value: row => +row.peso_descuento_humedad_perc / 100,
            format: '0.00%',
          }),
          { label: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})`, value: row => +row.peso_neto, format: '0.00' },
          ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
            label: `PESO NETO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            value: row => +row.peso_neto_extra,
            format: '0.00',
          }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_tipo_maduracion, { label: 'MADURACIÓN', value: 'tipo_maduracion' }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_rendimiento, {
            label: 'RENDIMIENTO',
            value: row => +row.rendimiento / 100,
            format: '0.00%',
          }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_humedad, {
            label: 'HUMEDAD',
            value: row => +row.humedad / 100,
            format: '0.00%',
          }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_mancha, {
            label: 'DEFECTO',
            value: row => +row.mancha / 100,
            format: '0.00%',
          }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_color, { label: 'COLOR', value: 'color' }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_color_de_cafe, { label: 'COLOR', value: 'color_de_cafe' }),
          ...insertIf(!!+coopConfig?.config?.config_muestreo?.mostrar_aroma, { label: 'AROMA', value: 'aroma' }),
          { label: 'OBSERVACIONES', value: 'observaciones' },
          // Mostrar solo si la cooperativa tiene en su configuracion el uso de calidad (coopConfig.config.usa_calidad)
          ...insertIf(!!+coopConfig.config?.usa_calidad, { label: 'ID MUESTRA', value: row => row.id_muestra || null }),
          ...insertIf(!!+coopConfig.config?.usa_calidad, { label: 'TIPO DE MUESTRA', value: row => row.tipo_muestra || null }),
          ...insertIf(!!+coopConfig.config?.usa_calidad, {
            label: 'RENDIMIENTO BRUTO',
            value: row => toPercent(row.rendimiento_bruto),
            format: '0.00%',
          }),
          ...insertIf(!!+coopConfig.config?.usa_calidad, {
            label: 'RENDIMIENTO EXPORTABLE',
            value: row => toPercent(row.rendimiento_exportable),
            format: '0.00%',
          }),
          ...insertIf(!!+coopConfig.config?.usa_calidad, {
            label: 'RENDIMIENTO REAL',
            value: row => toPercent(row.rendimiento_real),
            format: '0.00%',
          }),
          ...insertIf(!!+coopConfig.config?.usa_calidad, {
            label: 'PUNTAJE EN TAZA',
            value: row => toNumber(row.puntaje_manual),
            format: '0.00',
          }),
          ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
            label: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnits()?.abreviacion})`,
            value: row => +row.precio_por_kg,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          }),
          ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
            label: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            value: row => +row.precio_por_kg_extra,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          }),
          {
            label: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
            value: row => +row.importe_total,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          },
          ...insertIf(getIdCatCreditoPrecosecha() > 1, {
            label: 'DESCUENTOS DEUDAS',
            value: row => +row.total_anticipos_recuperados,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          }),
          {
            label: `PAGADO A PRODUCTOR (${coopConfig.currency()?.symbol})`,
            value: row => +row.pagado_a_productor,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          },
          {
            label: `SALDO DE LA ENTREGA (${coopConfig.currency()?.symbol})`,
            value: row => +row.total_saldo,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          },
          { label: 'MÉTODO DE PAGO', value: 'metodo_pago' },
        ],
        content: data,
      },
    ];

    let settings = {
      fileName: filename,
    };
    xlsx(xlsData1, settings);
  };

  const handleClickEditarEntrega = () => {

  
    if (coopConfig.acopioPagoXKilos()) {
      if (selectedData.total_anticipos_recuperados > 0 || selectedData.pagado_a_productor > 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No se pueden editar esta entrega debido a los pagos vinculados. Favor de contactar al equipo de sirio.',
        });
        return;
      }
    }else{
      if (selectedData.total_registros_anticipos > 0 || selectedData.total_registros_pagos > 1) {
        Swal.fire({
          icon: 'warning',
          text: `No se puede editar esta entrega debido a los ${selectedData.total_registros_anticipos > 0 ? 'anticipos' : 'pagos'} vinculados. Favor de contactar al equipo de sirio.`,
        });
        return;
      }

    }



    history.push(
      `/admin/acopio/entregas_por_productor/form/${selectedData.productor_id}/${selectedData.productor_uuid}/${selectedData.acopio_uuid}`
    );
  };

  return (
    <div>
      <div className="row justify-content-between mb-2">
        <SelectCiclo
          setFilter={evt => {
            setFilter(evt);
          }}
          acopio
        />

        {/* descarga de excel */}
        <div className="col-3">
          {ciclo?.uuid && auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_EXPORTAR') && (
            <div className="d-flex justify-content-end mr-3" ref={menuRef}>
              <LinkDownloadExcel handleExport={() => setMenuVisible(true)} />
              {menuVisible && (
                <div
                  className="modal"
                  style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', padding: '16px' }}
                  onClick={() => setMenuVisible(false)}>
                  <div
                    className="modal-dialog"
                    onClick={e => e.stopPropagation()}
                    style={{ position: 'absolute', right: 30, width: '20%', top: 170 }}>
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Descargar Reporte</h5>
                        <button type="button" className="close" onClick={() => setMenuVisible(false)}>
                          <span>&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form style={{ padding: '16px' }}>
                          <div className="form-check pb-2">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="report"
                              value="all"
                              checked={report === 'all'}
                              onChange={e => setReport(e.target.value)}
                            />
                            <label className="form-check-label">Todas las entregas</label>
                          </div>
                          <div className="form-check pb-2">
                            <input
                              type="radio"
                              className="form-check-input"
                              name="report"
                              value="date"
                              checked={report !== 'all'}
                              onChange={e => setReport(e.target.value)}
                            />
                            <label className="form-check-label">Entregas por fecha</label>
                          </div>
                          {report === 'date' && (
                            <div className="form-group">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="DD/MM/YYYY"
                                value={date}
                                onChange={e => setDate(e.target.value)}
                              />
                            </div>
                          )}
                          {blockingReport && (
                            <div className="d-flex justify-content-start float-right">
                              <div
                                className="spinner-border text-warning mr-2"
                                role="status"
                                aria-hidden="true"
                                style={{ height: 24, width: 24 }}></div>
                              <span className="mt-1">Descargando ...</span>
                            </div>
                          )}
                          {!blockingReport && (
                            <button
                              type="submit"
                              className="btn btn-xs btn-outline-secondary btn-sirio float-right"
                              onClick={e => handleDownloadReport(e)}>
                              Descargar
                            </button>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12 px-0">
          <CardContainer height={'100%'}>
            <ListToolbar
              left={
                <SearchColumn
                  data={originalData}
                  columns={searchColumns}
                  setDataFilter={evt => setDataFilter(evt)}
                />
              }>
              <BtnNuevo
                show={auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_NUEVO') && ciclo?.id == coopConfig?.activeCicloAcopio()?.id}
                to="/admin/acopio/entregas_por_productor/seleccion">
                Nueva entrega
              </BtnNuevo>
              <BtnSecundario
                show={auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_NUEVO') && !coopConfig.acopioPagoXKilos()}
                icon="fa-plus"
                onClick={() =>
                  history.push(
                    `/admin/acopio/entregas_por_productor/pago_pendiente/${selectedData.productor_id}/${selectedData.productor_uuid}/${selectedData.id_acopio}`
                  )
                }
                disabled={!selectedData}>
                Pago pendiente
              </BtnSecundario>
              <BtnSecundario
                show={auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_NUEVO')}
                icon="fa-pen"
                onClick={handleClickEditarEntrega}
                disabled={!selectedData}>
                Editar entrega
              </BtnSecundario>
              <BtnEliminar
                show={auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_NUEVO')}
                onClick={() => eliminarEntrega()}
                disabled={!selectedData}>
                Eliminar
              </BtnEliminar>
            </ListToolbar>

            <EntregasXProductorTable
              blocking={blocking}
              selected="id"
              data={data}
              fnBackgroundColor={getBackgroundColor}
              fnColor={getColor}
              coopConfig={coopConfig}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />

            <ModalEntrega ref={dialog} title="Actualizar estado"></ModalEntrega>
          </CardContainer>
        </div>
      </div>
    </div>
  );
};

export default EntregasXProductorList;
